"use strict";

module.exports = function (regex, ErrorClass) {
  return {
    validate: function validate(val) {
      if (val && !regex.test(val)) {
        throw new ErrorClass(val);
      }
    }
  };
};
//# sourceMappingURL=regexValidator.js.map